import { Component } from 'react';

import { Button } from '@ce-cfbdigital/cgl-cfb-fe-foundation';
import PropTypes from 'prop-types';

import Select from '../Select';

import './styles/index.css';

class AccountAndRegionSelection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSelection: ''
    };
  }

  selectionChanged = value => {
    this.setState({
      currentSelection: value
    });
  };

  render() {
    const {
      selectOptions,
      placeholderValue,
      classNamePrefix,
      closeModal,
      callbackMethod,
      buttonClasses,
      confirmButtonLabel,
      defaultValue,
      headerLabel,
      cancelButtonLabel,
      noOptions
    } = this.props;
    const { currentSelection } = this.state;
    const valuesArr = selectOptions.sort((x, y) => {
      if (x.selected === y.selected) {
        return 0;
      }
      return x.selected ? -1 : 1;
    });

    return (
      <div className="selection-wrapper flex-group">
        <Select
          options={valuesArr}
          selectLabel={headerLabel}
          isSearchable
          classNamePrefix={classNamePrefix}
          defaultValue={defaultValue}
          className="select-box"
          onChange={value => this.selectionChanged(value)}
          isOptionDisabled={option => option.selected}
          placeholder={placeholderValue}
          noOptionsMessage={() => noOptions}
        />
        <div className="buttons-wrap lights-off">
          <Button
            buttonLabel={cancelButtonLabel}
            type="button"
            classes={`btn cancel ${buttonClasses}`}
            handleClick={closeModal}
          />
          <Button
            buttonLabel={confirmButtonLabel}
            type="button"
            classes={`btn confirm ${buttonClasses}`}
            handleClick={() => callbackMethod(currentSelection.value || defaultValue.value, false)}
          />
        </div>
      </div>
    );
  }
}

AccountAndRegionSelection.propTypes = {
  selectOptions: PropTypes.instanceOf(Object).isRequired,
  placeholderValue: PropTypes.string,
  callbackMethod: PropTypes.func.isRequired,
  classNamePrefix: PropTypes.string,
  buttonClasses: PropTypes.string,
  confirmButtonLabel: PropTypes.string,
  closeModal: PropTypes.func,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Object)]),
  cancelButtonLabel: PropTypes.string,
  headerLabel: PropTypes.string,
  noOptions: PropTypes.string
};

AccountAndRegionSelection.defaultProps = {
  defaultValue: '',
  placeholderValue: '',
  classNamePrefix: '',
  buttonClasses: '',
  cancelButtonLabel: 'Cancel',
  confirmButtonLabel: 'Confirm',
  headerLabel: '',
  noOptions: 'No Options',
  closeModal: () => {}
};

export default AccountAndRegionSelection;
